export default __webpack_public_path__ + "static/media/purchase_failed_image.dddd4d92.png";